import Layout from "../../layout/Layout";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getActivePrice } from "../../../utils/converter";
import { useEffect, useState } from "react";
import { getOneProductAction } from "../../../store/product/actions";
import ProductDetailsSkeleton from "./ProductDetailsSkeleton";
import {getOneProduct,productreset} from "../../../store/product/productSlice"

const Shop = () => {
  const { product, isLoading, isError, message } = useSelector((state: any) => state.product);
  const dispatch = useDispatch<any>();
  const { productId } = useParams<any>();
  const navigate = useNavigate();
  useEffect(() => {
    if(isError) {
      console.log(message)
    }
    if(!productId){
      navigate("/")

    }
    dispatch(getOneProduct(productId));

    // console.log(product);
    return () => {
      dispatch(productreset())
    }
  }, [isError,message,productId,navigate, dispatch]);



  const [imgItem, setImgItem] = useState(0);

  const [quantity, setQuantity] = useState(1);
  const storedCart = localStorage.getItem("cart");
  const [cart, setCart] = useState(storedCart ? JSON.parse(storedCart) : []);
  
  const handleAddToCart = () => {
    if (!product) {
      alert("Please select a product first.");
      return;
    }

    const productName = product?.product;
    const productPrice = getActivePrice(product?.prices) ?? "0";
    const productCategory = product?.category?.name;
    const productImage = product?.images[0];
    const productdescription= product?.description;

    const existingProductIndex = cart.findIndex(
      (item: any) => item.name === productName
    );
    console.log(existingProductIndex)

    if (existingProductIndex !== -1) {
      const updatedCart = [...cart];
      updatedCart[existingProductIndex].quantity = quantity; // Update quantity
      setCart(updatedCart);
      localStorage.setItem("cart", JSON.stringify(updatedCart));
    } else {
      const productInfo = {
        id: productId,
        picture: productImage,
        name: productName,
        price: productPrice,
        category: productCategory,
        quantity: quantity,
      };

      const updatedCart = [...cart, productInfo];
      setCart(updatedCart);
      localStorage.setItem("cart", JSON.stringify(updatedCart));
    }
  };

  const handleIncreaseQuantity = () => {
    setQuantity(quantity + 1);
  };

  const handleDecreaseQuantity = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  return (
    <Layout>
      {isLoading ? (

<ProductDetailsSkeleton />



      ) : (
<>
<div className="single-product-area section-padding-100 clearfix">
            <div className="container-fluid">
            <div className="row">
                    <div className="col-12 col-lg-7">
                        <div className="single_product_thumb">
                            <div id="product_details_slider" className="carousel slide" data-ride="carousel">
                            <ol className="carousel-indicators">
                            {product?.images.map((img: any, index: any) => (
                                    <li className={(imgItem === index) ? "active" : ""}  key={index} data-target="#product_details_slider" data-slide-to={index} onClick={() => setImgItem(index)} style={{backgroundImage: `url(${img})`}}>
                                    </li>
                                    
                               
                                ))}
                                 </ol>
                                <div className="carousel-inner">
                                {product?.images.map((img: any, index: any) => (
                                    <div className={(imgItem === index) ? "carousel-item active" : "carousel-item"} key={index}>
                                        <a className="gallery_img" href="#">
                                            <img className="d-block w-100" src={img} />
                                        </a>
                                    </div>
                                ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-5">
                        <div className="single_product_desc">
                            {/* <!-- Product Meta Data --> */}
                            <div className="product-meta-data">
                                <div className="line"></div>
                                <p className="product-price">{`RWF ${
                  getActivePrice(product?.prices)?.toLocaleString() ??
                  0
                }`}</p>
                                <a href="product-details.html">
                                    <h6>{product?.product}</h6>
                                </a>
                                {/* <!-- Ratings & Review --> */}
                                <div className="ratings-review mb-15 d-flex align-items-center justify-content-between">
                                    <div className="ratings">
                                        <i className="fa fa-star" aria-hidden="true"></i>
                                        <i className="fa fa-star" aria-hidden="true"></i>
                                        <i className="fa fa-star" aria-hidden="true"></i>
                                        <i className="fa fa-star" aria-hidden="true"></i>
                                        <i className="fa fa-star" aria-hidden="true"></i>
                                    </div>
                                    {/* <div className="review">
                                        <a href="#">Write A Review</a>
                                    </div> */}
                                </div>
                                {/* <!-- Avaiable --> */}
                                {product?.quantity > 0 ? (<p className="avaibility"><i className="fa fa-circle"></i> In Stock</p>) : (<p className="unavaibility"><i className="fa fa-circle"></i> Sold Out</p>)}
                            </div>

                            <div className="short_overview my-5">
                                <p>{product?.productDescription}</p>
                            </div>

                            {/* <!-- Add to Cart Form --> */}
                            {product?.quantity > 0 ? (
                            <form className="cart clearfix" method="post" onSubmit={(e) => e.preventDefault() }>
                                <div className="cart-btn d-flex mb-50">
                                    <p>Qty</p>
                                    <div className="quantity">
                                        <span className="qty-minus" onClick={handleDecreaseQuantity}><i className="fa fa-caret-down" aria-hidden="true"></i></span>
                                        <input type="number" className="qty-text" id="qty" step="1" min="1" max="300" name="quantity" value={quantity}/>
                                        <span className="qty-plus" onClick={handleIncreaseQuantity}><i className="fa fa-caret-up" aria-hidden="true"></i></span>
                                    </div>
                                </div>
                                <button name="addtocart" className="btn amado-btn" onClick={handleAddToCart}>Add to cart</button>
                            </form>) : (null)}

                        </div>
                    </div>


            </div>
        </div>
        </div>

</>


      )}

        
          </Layout>
  );
};

export default Shop;
